import 'intersection-observer';

import App from './components/app';
import {attachErrorListener} from './captureError';
import ThemeProvider from '@sproutsocial/seeds-react-theme-provider';
import {sproutLightTheme} from '@sproutsocial/seeds-react-theme';

import {createRoot} from 'react-dom/client';

import './styles.css';

attachErrorListener();

const root = createRoot(document.getElementById('app')!);
root.render(
	<ThemeProvider theme={sproutLightTheme}>
		<App />
	</ThemeProvider>
);
